import React, {useState} from 'react';
import "./main.scss"
import {
    HashRouter as Router,
    NavLink
  } from "react-router-dom";
import Icon from '@iconify/react';
import instagramOutlined from '@iconify/icons-ant-design/instagram-outlined';
import bxlTelegram from '@iconify/icons-bx/bxl-telegram';
import DropMenu from '../components/dropMenu/DropMenu';

function Main() {

    const width = window.innerWidth
    console.log(width);

    const [showSecond, setShow] = useState(false)
    const [showThird, setShowThird] = useState(false)
    const [showFourth, setShowFourth] = useState(false)
    const [showFifth, setShowFifth] = useState(false)

    return (
        <>
        <Router>
            <div className="fullMain">
                <div className="firstBlock">
                    {width<800&&<DropMenu />}
                    <div  className={showSecond || showThird || showFourth || showFifth? "overChange" :"firstBlockOverHeading"}>
                        WEB DEVELOPER
                    </div>
                    <div className="nameBlock">
                    <div className="firstBlockHeading">
                        Bohdan Yarish
                    </div>
                    <div className="firstBlockSubHeading">
                        Web developer
                    </div>
                    </div>
                </div>
                <div className="secondBlock" onMouseOut={() => (setShow(false))} onMouseOver={() => (setShow(true))}>
                    <div className="secondBlockText">SKILLS</div>
                    <div className={showSecond? "secondUnderText" : "none"}>skills</div>
                    <NavLink to="/skills" className={showSecond? "link" : "none"}><div className="frame">
                    <div className="button">
                        <span>SHOW PAGE</span>
                        <svg>
                        <polyline class="o1" points="0 0, 150 0, 150 55, 0 55, 0 0"></polyline>
                        <polyline class="o2" points="0 0, 150 0, 150 55, 0 55, 0 0"></polyline>
                    </svg>
                    </div>
                </div></NavLink>
                </div>
                <div className="thirdBlock"onMouseOut={() => (setShowThird(false))} onMouseOver={() => (setShowThird(true))}>
                    <div className="thirdBlockText" >ABOUT </div>
                    <div className='aboutMe'>ME</div>
                    <NavLink className={showThird? "link":"none"} to="/about"><div className="frame">
                    <div className="button">
                        <span>SHOW PAGE</span>
                        <svg>
                        <polyline class="o1" points="0 0, 150 0, 150 55, 0 55, 0 0"></polyline>
                        <polyline class="o2" points="0 0, 150 0, 150 55, 0 55, 0 0"></polyline>
                    </svg>
                    </div>
                </div></NavLink>
                </div>
                <div className="fourthBlock" onMouseOut={() => (setShowFourth(false))} onMouseOver={() => (setShowFourth(true))}>
                    <div className="fourthBlockText">WORKS</div>
                    <div className={showFourth? "secondUnderText" : "none"}>works</div>
                    <NavLink className={showFourth? "link":"none"} to="/works"><div className="frame">
                    <div className="button">
                        <span>SHOW PAGE</span>
                        <svg>
                        <polyline class="o1" points="0 0, 150 0, 150 55, 0 55, 0 0"></polyline>
                        <polyline class="o2" points="0 0, 150 0, 150 55, 0 55, 0 0"></polyline>
                    </svg>
                    </div>
                </div></NavLink>
                </div>
                <div className="fifthBlock" onMouseOut={() => (setShowFifth(false))} onMouseOver={() => (setShowFifth(true))}>
                    <div className="fifthBlockText">CONTACTS</div>
                    <div className={showFifth? "secondUnderText" : "none"}>Contacts</div>
                    <a href="https://www.instagram.com/_yarish/" className={showFifth? "contactsLink" : "none"}>
                        <Icon icon={instagramOutlined} className="contactsIcon"/>
                        <div className="contactsLinkText">instagram</div>
                        <div className="contactsLinkName">_yarish</div>
                    </a>
                    <a href="https://t.me/yarisheo" className={showFifth? "contactsLink second" : "none"}>
                        <Icon icon={bxlTelegram}  className="contactsIcon"/>
                        <div className="contactsLinkText secondLink">telegram</div>
                        <div className="contactsLinkName secondName">yarisheo</div>
                    </a>
                    {/* <a href="https://www.instagram.com/_yarish/" className={showFifth? "contactsLink third" : "none"}>
                        <Icon icon={githubFilled}  className="contactsIcon"/>
                        <div className="contactsLinkText thirdLink">gitHub</div>
                        <div className="contactsLinkName">yarishb</div>
                    </a> */}
                </div>
            </div>
            </Router>
        </>
    );
}

export default Main;
